module.exports = __webpack_public_path__ + "9cfcd32b9fc6f518b25c63ca5f454a6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/close-circle.svg
// module id = 742
// module chunks = 0